"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthCookie = exports.UserHandleCookie = void 0;
/* TODO: move this const to some sort of "network-layer" shared package that can be used by each of the following:
    1. cloudflare proxy worker
    2. browser service worker
    3. frontend app code
    occurrences that need centralization:
    - ./packages/constants/src/cookies.ts
    - ./infra/pulumi/frontend-proxy/src/userRedirect.ts
    - ./frontend/src/service-worker.ts
 */
exports.UserHandleCookie = "flux_user_handle";
exports.AuthCookie = "flux-claims";
//# sourceMappingURL=cookies.js.map